export const healthdirectPalette = {
  primary: {
    main: '#1e4759',
    light: '#2a5f73',
    dark: '#153540',
    contrastText: '#ffffff',
  },
  success: {
    main: '#009f96',
    light: '#33b3ab',
    dark: '#008a81',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#d4533a',
    light: '#f2896f',
    dark: '#b83d28',
    contrastText: '#ffffff',
  },
  info: {
    main: '#d98e34',
    light: '#f5b672',
    dark: '#c27a1f',
    contrastText: '#ffffff',
  },
  error: {
    main: '#dc5456',
    light: '#e57577',
    dark: '#c93c3e',
    contrastText: '#ffffff',
  },
};
